import { Dispatch, SetStateAction } from "react";
import { IProduct } from "../../interfaces/IProducts";
import { TSHIRT_CHOICES } from "./BBEnum";
import BBHelperClass from "../../classes/BBHelperClass";
import HelperClass from "../../classes/HelperClass";

export interface IBBTshirt {
    tshirtId: number;
    setShirtId: Dispatch<SetStateAction<number>>;
    products?: IProduct[];
}

export interface IBBTshirtElement extends IBBTshirt {
    type: TSHIRT_CHOICES;
}
/* ------------------------------------------------ 
 * 
   ------------------------------------------------ */
// const BBTshirtElement = (props: IBBTshirtElement) => {
//     return (
//         <>
//             <a
//                 onClick={() => {
//                     props.setShirtId(props.id);
//                 }}
//             >
//                 <span className={"tag mr-2 " + (props.id === props.tshirtId ? "is-primary" : "is-light")}>{props.label}</span>
//             </a>
//         </>
//     );
// };
/* ------------------------------------------------ 
 * 
   ------------------------------------------------ */
// const BBTshirtGroup = (props: IBBTshirtElement) => {
//     return (
//         <>
//             <a
//                 onClick={() => {
//                     props.setShirtId(props.id);
//                 }}
//             >
//                 <span className={"tag mr-2 " + (props.id === props.tshirtId ? "is-primary" : "is-light")}>{props.label}</span>
//             </a>
//         </>
//     );
// };

/* -------------------------------------------------
 * baner w sklepie
 * ------------------------------------------------- */
export const BBTshirtShop = (props: { tshirtType: TSHIRT_CHOICES; products?: IProduct[] }) => {
    return (
        <>
            {/* <div className="media">
                <div className="media-left">
                    <figure className="image is-48x48">
                        <img src={ActivityMatrix[props.activityType].icon.toString()} alt={ActivityMatrix[props.activityType].title} />
                    </figure>
                </div>
                <div className="media-content">
                    <p className="title is-4">{ActivityMatrix[props.activityType].title}</p>
                    <p className="subtitle is-6">
                        minimum {ActivityMatrix[props.activityType].distance}
                        {ActivityMatrix[props.activityType].distanceWalk}
                        {ActivityMatrix[props.activityType].distanceWalk && " + "}
                        {ActivityMatrix[props.activityType].distanceRun}
                        {ActivityMatrix[props.activityType].distanceRun && " + "}
                        {ActivityMatrix[props.activityType].distanceRide}
                        &nbsp;km
                        <p>
                            <strong>{BBHelperClass.getActivityPrice(props.activityType, props.bbActivities)} </strong>
                            <small>zł</small>
                        </p>
                        {/* <p>
                            <a href="">więcej informacji</a>
                        </p> }
                    </p>
                </div>
            </div> */}
        </>
    );
};
/* ------------------------------------------------ 
 * 
   ------------------------------------------------ */
const BBTshirts = (props: IBBTshirt) => {
    function showTshirt(tshirtType: TSHIRT_CHOICES) {
        let tshirtObj = BBHelperClass.getProductFromInStoreByVariant(tshirtType, props.products);
        if (tshirtObj != undefined) {
            return (
                <div className="column">
                    <div className={"card " + (HelperClass.isProductInStore(props.tshirtId, tshirtObj.inStore) && "has-background-info-light")}>
                        {/* <div className={"card "}> */}
                        <div className="card-content pb-1">
                            <div className="card-content">
                                <p className="title is-4">{tshirtObj.prodDef?.name}</p>
                                <p className="is-size-7">wybierz rozmiar</p>
                                {tshirtObj.inStore?.map((tshirtVariant, index) => (
                                    <a
                                        onClick={() =>
                                            tshirtVariant.productId &&
                                            props.setShirtId(tshirtVariant.productId == props.tshirtId ? 0 : tshirtVariant.productId)
                                        }
                                    >
                                        <span
                                            key={"tshortvariant" + tshirtVariant.productId?.toString}
                                            className={"tag mr-2 p-4 " + (tshirtVariant.productId === props.tshirtId ? "is-primary" : "is-light")}
                                        >
                                            {tshirtVariant.vName}
                                        </span>{" "}
                                    </a>
                                ))}
                                {/* <BBTshirtShop activityType={activity} bbActivities={props.bbActivities} /> */}
                            </div>
                        </div>
                        <div className="pl-4 pb-1">
                            <a href="">więcej informacji</a>
                        </div>
                    </div>
                </div>
            );
        }
        return <></>;
    }

    return (
        <div className="container">
            <div className="columns">
                {showTshirt(TSHIRT_CHOICES.PROD_VARIANT_TSHIRT_W)}
                {showTshirt(TSHIRT_CHOICES.PROD_VARIANT_TSHIRT_M)}
            </div>
        </div>
    );
};
export default BBTshirts;
